
import { useSearchParams } from 'react-router-dom'

const ProgressBar = () => {
  const [searchParams] = useSearchParams();
  const p = searchParams.get("p");
  const setColor = Number(p) < 8 ? 'yellow' : 'green';

  return (
    <div className="progressber">
        <div className="step">
            <p><span className={setColor}>{p}</span>/12</p>
        </div>
        <div className={`ber-bg bg-${setColor} p-${p}`}></div>
        <div className={`ber op-${setColor}`}></div>
    </div>
  )
}
  
  export default ProgressBar